import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {IpdPatientCasePaperComponent} from './ipd-patient-case-paper.component';

const routes: Routes = [
  {
    path: 'ipd-patient-case-report/:source/:admission_id', component: IpdPatientCasePaperComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd-patient-case-paper/ipd-patient-case-paper.routing.ts